import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Snackbar, Alert
} from '@mui/material';
import axiosInstance from '../../../utils/axios';

const DeleteDialog = ({selectedId, setSelectedId, open, setOpen, handleFetch, text}) => {
    const [loader, setLoader] = useState(false)

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedId(null);
  };

  const handleConfirmDelete = async () => {
    setLoader(true)
    try {
      await axiosInstance.delete(`/projects/delivery?delivery_id=${selectedId}`);
      setSnackbar({ open: true, message: 'Deleted successfully!', severity: 'success' });
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Failed to delete item.', severity: 'error' });
    } finally {
      handleCloseDialog();
      setLoader(false)
      handleFetch()
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
        <Typography>
            Please confirm if you want to delete the delivery reference{' '}
            <Typography component="span" fontWeight={600}>
                {text}
            </Typography>{' '}
            and all its associated documents.
            </Typography>        
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
          <Button onClick={handleConfirmDelete} loading={loader} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteDialog;
